import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Layout } from '../components/Layout';
import LogIn from './routes/Login';
import ForgotPassword from './routes/ForgotPassword';
import ForgotPasswordConfirmation from './routes/ForgotPasswordConfirmation';
import ResetPassword from './routes/ResetPassword';
import ResetPasswordConfirmation from './routes/ResetPasswordConfirmation';
import ConfirmRegistration from './routes/ConfirmRegistration';
import SocialLogin from './routes/SocialLogin';
import PluginLoginConfirmed from './routes/PluginLoginConfirmed';
import ExternalLoginError from './routes/ExternalLoginError';
import AuthThemeProvider from 'themes/AuthThemeProvider';
import Register from './routes/Register';
import RegisterSuccess from './routes/RegisterSuccess';
import ConfirmEmail from './routes/ConfirmEmail';
import ConfirmProviderEmail from './routes/ConfirmProviderEmail';

export default class App extends Component {
    render() {
        const { match } = this.props;
        return (
            <AuthThemeProvider>
                <Layout>
                    <Switch>
                        <Route path={`${match.url}/login`} component={LogIn} />
                        <Route path={`${match.url}/forgotPasswordConfirmation`} component={ForgotPasswordConfirmation} />
                        <Route path={`${match.url}/forgotPassword`} component={ForgotPassword} />
                        <Route path={`${match.url}/resetPassword`} component={ResetPassword} />
                        <Route path={`${match.url}/resetPasswordConfirmation`} component={ResetPasswordConfirmation} />
                        <Route path={`${match.url}/confirmRegistration`} component={ConfirmRegistration} />
                        <Route path={`${match.url}/socialLogin`} component={SocialLogin} />
                        <Route path={`${match.url}/externalLoginError`} component={ExternalLoginError} />
                        <Route path={`${match.url}/pluginLoginConfirmed`} component={PluginLoginConfirmed} />
                        <Route path={`${match.url}/psPluginLoginConfirmed`} component={PluginLoginConfirmed} />
                        <Route path={`${match.url}/xdPluginLoginConfirmed`} component={PluginLoginConfirmed} />
                        <Route path={`${match.url}/ilPluginLoginConfirmed`} component={PluginLoginConfirmed} />
                        <Route path={`${match.url}/ExPluginLoginConfirmed`} component={PluginLoginConfirmed} />
                        <Route path={`${match.url}/register`} component={Register} />
                        <Route path={`${match.url}/registersuccess`} component={RegisterSuccess} />
                        <Route path={`${match.url}/confirmEmail`} component={ConfirmEmail} />
                        <Route path={`${match.url}/confirmProviderEmail`} component={ConfirmProviderEmail} />
                        <Route component={() => <div>Not Found</div>} />
                    </Switch>
                </Layout>
            </AuthThemeProvider>
        );
    }
}